module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "gPageBorder",
    attrs: {
      "id": "myApp"
    }
  }, [_c('el-dialog', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "title": _vm.dialogConfig.tip,
      "visible": _vm.dialogTopMgVisible,
      "size": "tiny"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogTopMgVisible = $event
      }
    }
  }, [_c('el-button', {
    staticStyle: {
      "width": "20%"
    },
    on: {
      "click": function($event) {
        _vm.processRecommend(0)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_no')))]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "20%",
      "width": "20%"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.processRecommend(1)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_yes')))])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_c('el-button', {
    staticClass: "gSgLeftBtn",
    attrs: {
      "type": "success"
    },
    on: {
      "click": _vm.addVideo
    }
  }, [_vm._v(_vm._s(_vm.$t('app_advdoad')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": _vm.allUndercarriage
    }
  }, [_vm._v(_vm._s(_vm.$t('app_mulDel')))]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.usrType === '0'),
      expression: "usrType === '0'"
    }],
    staticStyle: {
      "margin-left": "24px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.goDefault
    }
  }, [_vm._v(_vm._s(_vm.$t('app_mgdfvdo')))])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "gSideCtrl"
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('app_adname'),
      "icon": "search",
      "on-icon-click": _vm.query
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.query($event)
      }
    },
    model: {
      value: (_vm.queryKey),
      callback: function($$v) {
        _vm.queryKey = $$v
      },
      expression: "queryKey"
    }
  })], 1)])], 1), _vm._v(" "), _c('div', [_c('el-table', {
    ref: "multipleTable",
    staticClass: "tbPoint gTopMg",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData,
      "border": "",
      "tooltip-effect": "dark"
    },
    on: {
      "row-click": _vm.cellClick,
      "selection-change": _vm.handleSelectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "align": "center",
      "type": "selection",
      "width": "55"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "videoname",
      "label": _vm.$t('app_ad') + _vm.$t('app_name'),
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "duration",
      "label": _vm.$t('app_addur'),
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "createTime",
      "formatter": _vm.dateFormat,
      "label": _vm.$t('app_tofvalis'),
      "width": "200"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('label', [_vm._v(_vm._s(_vm.timeLimit(scope.row)))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "appVersion",
      "align": "center",
      "label": _vm.$t('app_adstatus'),
      "width": "110"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('label', {
          style: (_vm.getStatus(scope.row) ? _vm.getStatus(scope.row).style : '')
        }, [_vm._v(_vm._s(_vm.getStatus(scope.row) ? _vm.getStatus(scope.row).vl : ''))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "operate",
      "align": "right",
      "header-align": "center",
      "label": _vm.$t('app_operate'),
      "width": "106"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('app_edit'),
            "placement": "top"
          }
        }, [_c('el-button', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: ((scope.row.status == 0 || scope.row.status == 3 || scope.row.status == 4 || scope.row.status == 5)),
            expression: "(scope.row.status == 0 || scope.row.status == 3 || scope.row.status == 4 || scope.row.status == 5)"
          }],
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.editVideo(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-pencil"
        })])], 1), _vm._v(" "), _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('app_smVerify'),
            "placement": "top"
          }
        }, [_c('el-button', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (scope.row.status !== 1 && scope.row.status !== 2),
            expression: "scope.row.status !== 1 && scope.row.status !== 2"
          }],
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.submitVideo(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-external-link-square"
        })])], 1), _vm._v(" "), _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('app_del'),
            "placement": "top"
          }
        }, [_c('el-button', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (true),
            expression: "true"
          }],
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.deleteVideo(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-trash-o",
          staticStyle: {
            "color": "#FF4949"
          }
        })])], 1)]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "gPgDiv"
  }, [_c('el-pagination', {
    staticClass: "gPg",
    attrs: {
      "current-page": _vm.index,
      "page-sizes": _vm.$gRows,
      "page-size": _vm.row,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.total
    },
    on: {
      "current-change": _vm.pageSelect,
      "size-change": _vm.pageSized
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1627e91e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/advert/video/list.vue
// module id = 976
// module chunks = 0